<template>
	<div class="login">
		<flLoad />
		<notifications group="notify" width="400" position="top center" />
		<flModalErro />
		<flQrCode
			v-if="!_isMobile"
			:link="link"
			:show="exiberQr"
			@fechou="() => (exiberQr = false)"
		/>
		<div
			class="main"
			:style="{backgroundImage: 'url(' + backgroundImage + ')', opacity}"
		></div>

		<!-- FORM -->
		<div class="main">
			<!-- tela de login -->
			<div class="container-fluid" style="z-index: 10" v-show="exibeLogin">
				<div class="row" :style="{'margin-top': _isMobile ? '20px' : '90px'}">
					<!-- exibe uma faixa para os clientes q customizam o bk -->
					<div v-if="!_isMobile && exibeFaixa" class="faixa col-md-12"></div>

					<div v-if="_isMobile" class="col-xs-4 col-sm-2 col-md-4"></div>

					<div
						class="col-md-8 animated fadeIn col-lg-8 text-center"
						:style="{'margin-top': style.marginTop}"
						v-if="!_isMobile"
					>
						<img :src="logoInicio" :style="{width: style.width}" />
						<H1
							class="h1-login"
							:class="exibeFaixa ? 'h1-login-faixa' : ''"
							v-html="textoLogin"
						></H1>
					</div>

					<!-- logo com o form para logar -->
					<div class="col-xs-12 col-sm-8 col-md-4 col-lg-3" style="z-index: 2">
						<div
							class="row login animated fadeInLeft"
							style="border: 1px solid #ddd"
						>
							<div class="col-xs-12 text-center">
								<flSelectTraducao />
							</div>

							<div class="col-xs-12">
								<div class="row text-center" style="margin-bottom: 16px">
									<img
										v-show="versao_sistema == 'P'"
										src="../../../assets/img/logo_police.png"
									/>
									<img
										v-show="versao_sistema == 'F'"
										src="../../../assets/img/logo_fire.png"
									/>
									<img
										v-show="versao_sistema == 'TX'"
										src="../../../assets/img/logo_tx.png"
									/>
									<img
										v-show="versao_sistema == 'G'"
										src="../../../assets/img/logo_green.png"
									/>
									<img
										v-show="versao_sistema == 'M'"
										src="../../../assets/img/logo_med.png"
									/>
									<img
										v-show="versao_sistema == 'E'"
										src="../../../assets/img/logo_school.png"
									/>
									<img
										v-show="versao_sistema == 'C'"
										src="../../../assets/img/logo_corporate.png"
									/>
									<img
										v-show="versao_sistema == 'GV' && idCliente != 8"
										src="../../../assets/img/logo_gov.png"
									/>
									<!-- <img v-show="versao_sistema == 'GV' && idCliente == 8" src="../../../../assets/img/logo_cmg.png"   /> -->
								</div>

								<div class="row">
									<!-- quando o periodo de teste acaba -->
									<div class="col-xs-12 text-center" v-if="texteFinalizado">
										<h3>{{ _traducao('global', 'periodoDeTesteAcabou') }}.</h3>
										<h3>{{ _traducao('global', 'entreEmContatoConosco') }}.</h3>
										<h3>{{ telefoneEmpresa }}</h3>
									</div>

									<!-- formulário para logar -->
									<form @submit.prevent="logarPadrao" v-if="!texteFinalizado">
										<!-- LOGIN -->
										<div class="col-xs-12" v-if="loginPadrao">
											<div
												class="form-group"
												:class="{'has-error': textoErro != ''}"
											>
												<a @click="clickLoginPadrao" v-if="loginAzure">
													<span style="cursor: pointer"
														><i
															class="fa fa-fw fa-arrow-left"
															aria-hidden="true"
														></i
													></span>
												</a>
												<input
													type="text"
													style="font-size: 16px"
													v-model="login"
													:placeholder="_traducao('login', 'digiteLogin')"
													class="form-control input-lg text-center"
													autofocus
												/>
											</div>
										</div>

										<!-- SENHA -->
										<div
											class="col-xs-12"
											style="padding-bottom: 0px"
											v-if="loginPadrao"
										>
											<div
												class="form-group"
												:class="{'has-error': textoErro != ''}"
												style="margin-top: 0; margin-bottom: 0px"
											>
												<input
													type="password"
													v-model="senha"
													style="font-size: 16px"
													:placeholder="_traducao('login', 'digiteSenha')"
													class="form-control input-lg text-center"
												/>
											</div>

											<!-- ESQUECI A MINHA SENHA -->
											<div class="row" v-if="!loginIAM">
												<div
													class="col-xs-12 text-center"
													style="margin-top: 0px"
												>
													<a href="#" @click.prevent="clickTrocarSenha()">
														{{ _traducao('global', 'esqueciMinhaSenha') }}
													</a>
												</div>
											</div>

											<!-- MSG DE ERRO -->
											<div class="col-xs-12" v-show="textoErro != ''">
												<div style="margin-top: 0px">
													<div
														class="alert alert-danger alert-dismissible fade in"
														style="margin-top: 0px; margin-bottom: 0px"
														role="alert"
													>
														<p class="text-center">{{ textoErro }}</p>
													</div>
												</div>
											</div>
										</div>
										<!-- BOTAO ENTRAR -->
										<div v-if="loginAzure">
											<div
												class="col-xs-12 text-center"
												style="margin-top: 10px"
												v-if="!loginPadrao"
											>
												<div class="form-group" style="margin-top: 0px">
													<a
														href="https://vale.followair.com.br/ws/public/Usuario/logar?login=azure"
														class="btn btn-lg btn-primary btn-login"
													>
														Logar Azure
													</a>
													<a @click="clickLoginPadrao">
														<span style="cursor: pointer"
															><i
																class="fa fa-fw fa-arrow-right"
																aria-hidden="true"
															></i
														></span>
													</a>
												</div>
											</div>
											<div class="row">
												<div class="col-xs-12">
													<hr class="hr-2" />
												</div>
											</div>
										</div>

										<div
											class="col-xs-12 text-center"
											style="margin-top: 10px"
											v-if="loginPadrao"
										>
											<div class="form-group" style="margin-top: 0px">
												<!-- <a
													href="https://vale.followair.com.br/ws/public/Usuario/logar"
                          class="btn btn-lg btn-primary btn-login"
                        > Entrar </a> -->
												<button
													type="submit"
													@click="logarPadrao()"
													class="btn btn-lg btn-primary btn-login"
												>
													Entrar
												</button>
												<a @click="clickLoginPadrao" v-if="!loginPadrao">
													<span style="cursor: pointer"
														><i
															class="fa fa-fw fa-arrow-right"
															aria-hidden="true"
														></i
													></span>
												</a>
											</div>

											<div class="row">
												<div class="col-xs-12">
													<hr class="hr-2" />
												</div>
											</div>
										</div>
									</form>

									<!-- RELATORIO DE PREVENCAO -->
									<div
										class="row"
										style="padding-right: 15px"
										v-if="realprev === '1'"
									>
										<div
											class="col-xs-12"
											style="cursor: pointer"
											@click.prevent="modalPrevensao()"
										>
											<div style="display: flex; align-items: center">
												<i
													class="icon-solicitacao_nova_solicitacao icon-rel-prevencao pull-left"
													style="margin-top: 4px"
												></i>
												<h4 class="h3-prevencao">
													{{
														_traducao(
															'global',
															'relatorioPrevencao'
														).toUpperCase()
													}}
													<!-- {{_labelRelatorioPrevencao.titulo.toUpperCase()}} -->
												</h4>
											</div>
										</div>
									</div>
								</div>

								<!-- IMAGEM E TEXTO PRA QUANDO FOR MOBILE -->
								<div class="row" v-if="_isMobile">
									<div class="col-xs-12 text-center">
										<img :src="logoInicio" />
										<h5 class="texto-empresa-1" v-html="textoLogin"></h5>
									</div>
								</div>

								<!-- acesso ao app e a versão do sistema -->
								<div class="row" v-if="aplicativo === '1'">
									<div class="col-xs-12" style="margin-top: 0px">
										<a
											href="#"
											class="pull-right"
											v-if="!texteFinalizado && !_isMobile"
											@click.prevent="exiberQr = true"
										>
											<i class="fa fa-fw fa-mobile" aria-hidden="true"></i>
											{{ _traducao('global', 'acessarApp') }}
										</a>
									</div>
								</div>

								<p
									class="versao"
									:class="{
										'pull-left': !_isMobile,
										'text-center': _isMobile
									}"
								>
									<i
										class="fa fa-laptop fa-fw"
										aria-hidden="true"
										style="margin-left: 4px"
									></i>
									{{ versao_back }} | {{ versao_front }}
								</p>

								<!-- notas da versão -->
								<div class="row">
									<div class="col-xs-12">
										<a
											href="#"
											class="pull-left"
											style="margin-bottom: 8px"
											@click="abrirSobreWiki"
										>
											{{ _traducao('global', 'notasDaVersao') }}
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- MODAL RELATORIO -->
		<modal name="modal-relatorio">
			<button
				type="button"
				class="close"
				@click="_escondeModal('modal-relatorio')"
			>
				<span aria-hidden="true">&times;</span>
			</button>

			<h4 class="modal-title">
				<i
					class="fa icon-prevencao fa-fw"
					style="position: relative; top: 3px"
				></i>
				{{ _labelRelatorioPrevencao.titulo }}
			</h4>

			<hr style="margin-top: 10px; margin-bottom: 10px" />

			<form-cadastro-rel-prev
				:is-login="true"
				@imprimir-rel-prev="abrirPrintVisualizacaoRelPrev"
			/>
		</modal>

		<!-- MODAL TROCAR A SENHA -->
		<modal ref="modalAlterarSenha">
			<flTrocarSenha
				@alterou-senha="(senha) => logaUsuario('S', senha)"
				ref="trocaSenha"
			/>
		</modal>

		<!-- MODAL TROCA ASSINATURA -->
		<modal ref="modalAssinatura">
			<flTrocaAssinatura
				@alterou-assinatura="() => logaUsuario('A')"
				ref="trocaAssinatura"
			/>
		</modal>

		<!-- MODAL TERMO DE USO -->
		<modal ref="modalTermoDeUso">
			<button
				type="button"
				class="close"
				@click="$refs.modalTermoDeUso.modalHide()"
			>
				<span aria-hidden="true">&times;</span>
			</button>
			<h4 class="modal-title">
				{{ _traducao('global', 'termosDeUso').toUpperCase() }}
			</h4>

			<div class="row" style="margin-top: -34px">
				<div>
					<vue-editor
						:editor-toolbar="[{readOnly: true, modules: {toolbar: false}}]"
						:disabled="true"
						v-model="dataLogin.termo_uso"
					></vue-editor>
				</div>
			</div>

			<div class="row" style="margin-top: 15px">
				<div class="col-xs-12">
					<button
						class="btn btn-success pull-right"
						:disabled="tempoToDisabled != 0"
						type="buttom"
						@click="clickConcordo()"
					>
						<i class="fa fa-check fa-fw"></i>
						{{ _traducao('global', 'concordoComOsTermosDeUso').toUpperCase() }}
						<span v-if="tempoToDisabled != 0">({{ tempoToDisabled }})</span>
					</button>
				</div>
			</div>
		</modal>

		<!-- MODAL COM O ESQUECI A MINHA SENHA -->
		<modal name="modal-esqueci-senha">
			<flEsqueciSenha name="login" />
		</modal>

		<modal ref="modal_azure">
			<div class="row">
				<div class="col-xs-10">
					<h4>Login Azure</h4>
				</div>
				<div class="col-xs-2">
					<a
						href="#"
						@click.prevent="$refs.modal_azure.modalHide()"
						class="close pull-right"
						>&times;</a
					>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<hr style="margin: 5px 0px" />
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 text-center">
					<h3>
						Identificamos uma sessão ativa na Azure. <br /><br />
						Deseja fazer login no Followair usando as mesmas credenciais?
					</h3>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<hr style="margin: 5px 0px" />
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12" style="margin-top: 10px">
					<div style="margin-top: 0px">
						<button
							@click="$refs.modal_azure.modalHide()"
							class="btn btn-sm btn-danger float-left"
						>
							{{ _traducao('global', 'cancelar').toUpperCase() }}
						</button>
						<button
							@click="logarAzure()"
							class="btn btn-sm btn-primary pull-right"
						>
							{{ _traducao('login', 'entrar').toUpperCase() }}
						</button>
					</div>
				</div>
			</div>
		</modal>

		<fl-novo-usuario
			@salvou-novo-usuario="() => logaUsuario('E')"
			ref="novoUsuario"
		/>
	</div>
</template>

<script>
import flTrocarSenha from './trocar-senha.vue'
import flTrocaAssinatura from './trocar-assinatura.vue'
import flEsqueciSenha from './esqueci-senha.vue'
import flNovoUsuario from './novo-usuario.vue'
import FormCadastroRelPrev from '@/modules/layout/seguranca-operacional/relatorio-prevencao/components/form-cadastro.vue'

export default {
	components: {
		flEsqueciSenha,
		FormCadastroRelPrev,
		flTrocarSenha,
		flTrocaAssinatura,
		flNovoUsuario
	},

	data() {
		const loginPadrao = window.$cliente.get('login_azure') !== '1'
		return {
			login: '',
			senha: '',
			loginPadrao,

			backgroundImage:
				'https://services.followair.com.br/icones/img/fundo-1.png',

			novoUsuario: {
				e: false,
				senha: false,
				assinatura: false,
				termo: false
			},

			versao_sistema: '',
			versao_api: '',
			exibeFaixa: false,
			opacity: 0.7,

			textoLogin: '',
			logoInicio: '',

			exibeLogin: false,
			dataLogin: '',
			termo_uso: null,

			link: '',
			exiberQr: false,
			textoErro: '',
			tempoToDisabled: 20,
			flag: true,

			style: {},

			versao_back: '',
			versao_front: ''
		}
	},

	computed: {
		loginAzure() {
			return window.$cliente.get('login_azure') === '1'
		},

		loginIAM() {
			return window.$cliente.get('login_iam') === '1'
		},

		texteFinalizado() {
			return window.$cliente.get('teste_finalizado')
		},

		telefoneEmpresa() {
			return window.$cliente.get('telefone_empresa')
		},
		aplicativo() {
			return window.$cliente.get('aplicativo_tela_login')
		},
		realprev() {
			return window.$cliente.get('realprev_tela_login')
		},

		idCliente() {
			return window.$cliente.get('id')
		}
	},

	mounted() {
		window.$('body').css({'padding-top': '0px'})
		window.addEventListener('message', function (message) {
			if (
				message.origin == 'https://services.followair.com.br' &&
				sessionStorage.getItem('_POLICE_SESSION_') == null
			) {
				sessionStorage.setItem('_POLICE_SESSION_', message.data)
			}
		})
		this.atualizaInfos()
		this.logaRoute()
		this.abrirModalAzure()
		this.getVersao()

		const modalPrevencao = sessionStorage.getItem('MODAL_PREVENCAO')
		if (modalPrevencao) {
			this.modalPrevensao()
			sessionStorage.removeItem('MODAL_PREVENCAO')
		}
	},

	beforeDestroy() {
		this.flag = false
	},

	methods: {
		getVersao() {
			this._axios('/Cliente/get_versao', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						this.versao_back = retorno.lista.versao_back
						this.versao_front = retorno.lista.versao_front
					}
				}
			})
		},
		abrirModalAzure() {
			this._axios('/Usuario/logar_azure', 'get', {
				callback: (retorno) => {
					if (retorno._request && retorno._status) {
						if (retorno.login_azure == 1 && retorno.email) {
							this.$refs.modal_azure.modalShow(40)
						}
					}
				}
			})
		},

		clickLoginPadrao() {
			this.loginPadrao = !this.loginPadrao
		},

		logarAzure() {
			var data = {azure: true}

			this._httpPost('/Usuario/logar', data, (retorno) => {
				if (retorno._request) {
					window.bus.$emit('load-out')

					if (retorno._status && retorno.token.trim().length > 0) {
						this.logar(retorno)
						this.$refs.modal_azure.modalHide()
					} else {
						this.tipoNotificacao = 'danger'

						this.textoErro = retorno.mensagem
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.mensagem
						})
					}
				}
			})
		},

		logarPadrao() {
			var data = {logarPadrao: true, login: this.login, senha: this.senha}

			this.novoUsuario.e = false
			this.novoUsuario.senha = false
			this.novoUsuario.assinatura = false
			this.novoUsuario.termo = false

			this._httpPost('/Usuario/logar', data, (retorno) => {
				if (retorno._request) {
					window.bus.$emit('load-out')

					if (retorno._status && retorno.token.trim().length > 0) {
						let processar = false
						if (retorno.novo_usuario) {
							this.novoUsuario.e = true
							processar = true
						}

						if (retorno.atualiza_senha === '1') {
							this.novoUsuario.senha = true
							processar = true
						}

						if (retorno.atualiza_assinatura === '1') {
							this.novoUsuario.assinatura = true
							processar = true
						}

						if (retorno.assinar_termo === '1') {
							this.novoUsuario.termo = true
							processar = true
						}

						if (processar) {
							this.dataLogin = retorno
							this.processarAcesso()
						} else {
							this.logar(retorno)
						}
						this.$refs.modal_azure.modalHide()
					} else {
						this.tipoNotificacao = 'danger'

						this.textoErro = retorno.mensagem
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.mensagem
						})
					}
				}
			})
		},
		abrirSobreWiki() {
			window.open('https://wiki.followair.com.br/index.php/Sobre')
		},

		abrirPrintVisualizacaoRelPrev({id}) {
			window.bus.$emit('modal-hide', {name: 'modal-relatorio'})

			this.$router.push({
				name: 'login-relatorio-prevencao-visualizar',
				params: {id}
			})
		},

		logaUsuario(tipo, senha) {
			// voltou do alteração da senha
			if (tipo === 'S') {
				this.$refs.modalAlterarSenha.modalHide()
				this.novoUsuario.senha = false
				this.senha = senha
				this.processarAcesso()
			}

			// voltou do alteração da assinatura
			if (tipo === 'A') {
				this.$refs.modalAssinatura.modalHide()
				this.novoUsuario.assinatura = false
				this.processarAcesso()
			}

			// voltou da alteracao dos dados cadastrais
			if (tipo === 'E') {
				this.validaLogin()
			}
		},

		modalPrevensao() {
			window.bus.$emit('novo-prevencao', {exibeCabecalho: false})
			window.bus.$emit('modal-show', {name: 'modal-relatorio', width: 60})
		},

		clickTrocarSenha() {
			window.bus.$emit('carrega-esqueci-senha', this.login)
			this._exibeModal('modal-esqueci-senha', 45)
		},

		clickConcordo() {
			window.bus.$emit('load-in', {text: 'Concordando'})
			this._httpGet(
				'Usuario/assinar_termo/' + this.dataLogin.id_usuario,
				(retorno) => {
					window.bus.$emit('load-out')
					if (retorno._status && retorno._request) {
						this.$refs.modalTermoDeUso.modalHide()
						this.novoUsuario.termo = false
						this.processarAcesso()
					}
				},
				this.dataLogin.token
			)
		},

		validaLogin() {
			this.textoErro = ''

			if (this.login.trim() === '' || this.senha.trim() === '') {
				this.textoErro = this._traducao('login', 'textoErro')

				window.bus.$emit('exibir-notificacao', {
					type: 'danger',
					text: this.textoErro
				})
				return false
			}

			window.bus.$emit('load-in', {
				text: this._traducao('login', 'entrando').toUpperCase()
			})

			var data = {
				login: this.login,
				senha: this.senha
			}

			this.novoUsuario.e = false
			this.novoUsuario.senha = false
			this.novoUsuario.assinatura = false
			this.novoUsuario.termo = false

			this._httpPost('/Usuario/logar', data, (retorno) => {
				if (retorno._request) {
					window.bus.$emit('load-out')

					// deu certo, Login ok!
					if (retorno._status && retorno.token.trim().length > 0) {
						let processar = false
						if (retorno.novo_usuario) {
							this.novoUsuario.e = true
							processar = true
						}

						if (retorno.atualiza_senha === '1') {
							this.novoUsuario.senha = true
							processar = true
						}

						if (retorno.atualiza_assinatura === '1') {
							this.novoUsuario.assinatura = true
							processar = true
						}

						if (retorno.assinar_termo === '1') {
							this.novoUsuario.termo = true
							processar = true
						}

						if (processar) {
							this.dataLogin = retorno
							this.processarAcesso()
						} else {
							this.logar(retorno)
						}
					} else {
						this.tipoNotificacao = 'danger'

						this.textoErro = retorno.mensagem
						window.bus.$emit('exibir-notificacao', {
							type: 'danger',
							text: retorno.mensagem
						})
					}
				}
			})
		},

		logaRoute() {
			const name = this._idCliente == 33 ? 'manutencao' : 'monitoramento'
			if (
				sessionStorage.getItem('_POLICE_SESSION_') != null &&
				this.$router.currentRoute.name != name &&
				this.flag == true
			) {
				const id_indice_documento = sessionStorage.getItem(
					'ID_INDICE_DOCUMENTO'
				)
				if (id_indice_documento) {
					this.$router.replace({
						name: 'indice-documento-visualizar',
						params: {id: id_indice_documento}
					})
				} else {
					this.$router.replace({name})
				}
			}

			this.iniciaBuscaDados()
		},

		iniciaBuscaDados() {
			if (this.flag == true) {
				setTimeout(() => {
					this.logaRoute()
				}, 1000)
			}
		},

		processarAcesso() {
			if (this.novoUsuario.termo) {
				this.$refs.modalTermoDeUso.modalShow(80)
				this.tempoToDisabled = 30
				this.conta()
			} else if (this.novoUsuario.senha) {
				this.$refs.trocaSenha.carregaTrocarSenha(this.dataLogin)
				this.$refs.modalAlterarSenha.modalShow(45)
			} else if (this.novoUsuario.assinatura) {
				this.$refs.trocaAssinatura.carregaTrocaAssinatura(this.dataLogin)
				this.$refs.modalAssinatura.modalShow(45)
			} else if (this.novoUsuario.e) {
				this.$refs.novoUsuario.modalShow(this.dataLogin.token)
			} else {
				this.logar(this.dataLogin)
			}
		},

		logar(data) {
			for (var i in data.area) {
				data.area[i].lat = Number(data.area[i].lat)
				data.area[i].lng = Number(data.area[i].lng)
			}

			window.$sessao.setSessao(data.token, data.area)
			window.loginRecente = true

			const id_indice_documento = sessionStorage.getItem('ID_INDICE_DOCUMENTO')
			if (id_indice_documento) {
				this.$router.replace({
					name: 'indice-documento-visualizar',
					params: {id: id_indice_documento}
				})
			} else if (this._getPrivilegio(3) == false) {
				// se não tiver acesso ao monitoramento, carrega o login
				this.$router.replace({name: 'inicio'})
			} else {
				const name = this._idCliente == 33 ? 'manutencao' : 'monitoramento'
				// carrega o monitoramento
				this.$router.replace({name})
			}
		},

		conta() {
			if (this.tempoToDisabled !== 0) {
				setTimeout(() => {
					this.conta()
				}, 1000)
				this.tempoToDisabled-- // decrease the timer
			}
		},

		atualizaInfos() {
			this.logoInicio =
				window.$cliente.get('link_app') +
				'/clientes/' +
				window.$cliente.get('nome_pasta') +
				'/' +
				window.$cliente.get('img1') +
				'?' +
				this._getVersao()
			this.link = window.$cliente.get('link_ws')

			let sistema = window.$cliente.get('sistema')[0]

			this.versao_sistema = sistema.versao
			window.$cliente.setVersao(sistema)
			this.exibeLogin = true

			this.versao_api = window.$cliente.get('versao_api')

			if (!this._isMobile && window.$cliente.get('id') == '5') {
				this._httpGet('/Plano_fundo/get_ativo/', (retorno) => {
					if (retorno._request && retorno._status) {
						for (var i = 0; i < retorno.lista.length; i++) {
							this.backgroundImage =
								window.$cliente.get('link_app') +
								'/clientes/' +
								window.$cliente.get('nome_pasta') +
								'/' +
								retorno.lista[i].foto +
								'?' +
								this._getVersao()
							this.exibeFaixa = true
							this.opacity = 1
						}
					}
				})
			}

			if (window._.isNil(window.$cliente.get('texto_login'))) {
				this.textoLogin = window.$cliente.get('texto1')
			} else {
				this.textoLogin = window.$cliente.get('texto_login')
			}

			if (window._.isNil(window.$cliente.get('width_imagem_login'))) {
				this.style.width = '350px'
			} else {
				this.style.width = window.$cliente.get('width_imagem_login')
			}

			if (window._.isNil(window.$cliente.get('margin_top_imagem_login'))) {
				this.style.marginTop = '100px'
			} else {
				this.style.marginTop = window.$cliente.get('margin_top_imagem_login')
			}
		}
	}
}
</script>